import React from 'react';
import { saveUserInput, useUserInput } from '@store';
import { Account } from '@types';
import { useDispatch } from 'react-redux';

export const useSelectedAccount = () => {
	const dispatch = useDispatch();
	const { selectedAccount } = useUserInput();
	const setSelectedAccount = React.useCallback(
		(account: Account, companyName: string) => {
			if (
				(selectedAccount?.account !== undefined && selectedAccount?.account !== account) ||
				(selectedAccount?.companyName !== undefined && selectedAccount?.companyName !== companyName)
			) {
				dispatch(
					saveUserInput({
						selectedAccount: undefined,
						acceptedDebitInAccount: undefined,
						acceptedTermsAndConditionsBank: undefined,
						acceptedTermsAndConditionsSoftware: undefined,
					})
				);
			}
			dispatch(
				saveUserInput({
					selectedAccount: {
						account,
						companyName,
					},
				})
			);
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[selectedAccount?.account, selectedAccount?.companyName]
	);

	return { selectedAccount, setSelectedAccount };
};
